import { SuburbAutocomplete } from "@/components/SuburbAutocomplete";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export function CapabilityPicker({ options, value, onChange, prefix = "cap" }) {
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((c) => (
        <button key={c} type="button" onClick={() => toggle(c)} data-testid={`${prefix}-${c.toLowerCase().replace(/\s+/g, "-")}`}
          className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${value.includes(c) ? "bg-asphalt text-white border-asphalt" : "border-border hover:border-kinetic"}`}>{c}</button>
      ))}
    </div>
  );
}

export function BaseAreaFields({ v, set, prefix = "lead" }) {
  const label = v.suburb ? `${v.suburb}, ${v.state} ${v.postcode}` : "";
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <div className="space-y-1.5">
        <Label>Base suburb</Label>
        <SuburbAutocomplete value={label} testid={`${prefix}-suburb-input`}
          onSelect={(r) => {
            if (!r.postcode) { toast.error("Pick a suburb that shows a postcode"); return; }
            set({ ...v, suburb: r.suburb, state: r.state, postcode: r.postcode, lat: r.lat, lng: r.lon });
          }} />
      </div>
      <div className="space-y-1.5">
        <Label>Service radius: <span className="font-bold" data-testid={`${prefix}-radius-value`}>{v.max_service_radius_km} km</span></Label>
        <Input type="range" min="5" max="1000" step="5" value={v.max_service_radius_km} className="h-9 px-0 accent-[#E67E22]"
          onChange={(e) => set({ ...v, max_service_radius_km: parseInt(e.target.value, 10) })} data-testid={`${prefix}-radius-input`} />
      </div>
      <label className="flex items-center gap-3 text-sm sm:col-span-2">
        <Switch checked={v.is_interstate_capable} onCheckedChange={(c) => set({ ...v, is_interstate_capable: c })} data-testid={`${prefix}-interstate-switch`} />
        We do interstate and long-distance moves (over 200 km)
      </label>
    </div>
  );
}
